
import React from 'react';

const OpeningHook = () => {
  return (
    <div className="text-center mb-12 sm:mb-16 md:mb-20">
      <div className="max-w-4xl mx-auto">
        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-700 leading-relaxed font-medium mb-6 sm:mb-8">
          Tired of the endless grind selling the same web design, SEO, and lead gen services as every other agency?
        </p>
        <div className="relative">
          <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-[#003a70]/20 to-[#FEE6D8]/30 rounded-lg blur opacity-25"></div>
          <div className="relative bg-white border border-[#FEE6D8]/40 rounded-lg px-4 py-4 sm:px-6 sm:py-5 md:px-8 md:py-6 shadow-lg">
            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl text-[#003a70] font-bold leading-tight py-3 sm:py-4 md:py-6">
              What if there was a refreshingly simple, high-demand AI service you could offer{' '}
              <span className="bg-gradient-to-r from-[#FEE6D8] to-[#FEE6D8]/70 px-2 py-1 sm:px-3 sm:py-1 rounded-md sm:rounded-lg text-[#003a70] border border-[#FEE6D8]/50 inline-block mt-1 sm:mt-0">RIGHT NOW</span>{' '}
              that local businesses genuinely need?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpeningHook;
